// 核销管理
var CancellationCase = function () { return import('~/pages/cancellation-management/cancellation-case.vue'); };
export default [
    {
        path: '/cancellation-management/cancellation-case',
        name: 'cancellation-case',
        component: CancellationCase
    }
];
